import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse, LicenseClass } from '../models/model';
import { LicenseClassGetPaging } from '../services/licenseClassService';

interface LicenseClassState {
    items: LicenseClass[];
    loading: boolean;
    error: string | null;
}

const initialState: LicenseClassState = {
    items: [],
    loading: false,
    error: null,
};

export const fetchLicenseClasses = createAsyncThunk(
    'licenseClasses/fetchAll',
    async () => {
        const response: ApiResponse = await LicenseClassGetPaging({
            isActive: true
        });
        return response.result.items as LicenseClass[]; // giả sử API trả về danh sách
    }
);

const licenseClassSlice = createSlice({
    name: 'licenseClasses',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchLicenseClasses.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLicenseClasses.fulfilled, (state, action) => {
                state.items = action.payload;
                state.loading = false;
            })
            .addCase(fetchLicenseClasses.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Lỗi không xác định';
            });
    },
});

export default licenseClassSlice.reducer;
